// CSS
import "./styles/global.scss";

import 'parsleyjs';